<template>
  <v-app light>

    <v-navigation-drawer class="blue-grey darken-3" v-model="drawer" stateless fixed app clipped dark>
      <img src="static/img/meteor_logo_wht.png">
      <v-list expand>
        <item-list
          @add="handleAdd('network')"
          @display="handleDisplay('network', $event)"
          :items="$store.state.data.network"
          title="Network"></item-list>
        <item-list
          @add="handleAdd('station')"
          @display="handleDisplay('station', $event)"
          :items="$store.state.data.station"
          title="Station"></item-list>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer class="blue-grey darken-3" v-model="stationDrawer" temporary fixed hide-overlay stateless dark>
      <template v-if="$store.state.stationNode != null">
        <v-toolbar dense color="blue-grey darken-4">
          <v-btn @click="stationDrawer = false" icon><v-icon>arrow_back</v-icon></v-btn>
          <v-toolbar-title>
            <v-btn @click="handleDisplay('station', $store.state.stationNode)" flat>
              {{ $store.state.stationNode.label }}
              <span class="node-id">{{ $store.state.stationNode.id }}</span>
            </v-btn>
          </v-toolbar-title>
        </v-toolbar>
        <v-list expand>
          <item-list
            @add="handleAdd('location')"
            @display="handleDisplay('location', $event)"
            :items="$store.state.stationNode.location"
            title="Location"></item-list>
          <item-list
            @add="handleAdd('channel_collection')"
            @display="handleDisplay('channel_collection', $event)"
            :items="$store.state.stationNode.channel_collection"
            title="Channel collection"></item-list>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-toolbar color="blue-grey darken-4" app fixed dense dark clipped-left>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <label for="uploader" :style="{ cursor: 'pointer' }" class="v-btn v-btn--flat thene--dark">Load JSON</label>
        <v-menu offset-y>
          <v-btn slot="activator" flat>Export</v-btn>
          <v-list>
            <v-list-tile v-for="(fmt, i) in exportFormat" :key="i" @click="exportMetadata(fmt)">
              <v-list-tile-title>{{ fmt }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex lg10>

            <display-channel-collection
              v-if="$store.state.context == 'display' && $store.state.nodeType == 'channel_collection'"
              @clone="handleClone"
              @edit="handleEdit"
              @delete="handleDelete"
              @plotResponse="handlePlotResponse"
              :node-mapping="getNodeMapping()"
              :schema="$store.state.schema"
              :node="$store.state.node"
              :plot-values="plotValues"
            ></display-channel-collection>

            <display-node
              v-else-if="$store.state.context == 'display' && $store.state.nodeType != 'channel_collection'"
              @edit="handleEdit"
              @delete="handleDelete"
              :schema="$store.state.schema"
              :node="$store.state.node"
            ></display-node>

            <channel-form
              v-else-if="($store.state.context == 'edit' || $store.state.context == 'add') && $store.state.nodeType == 'channel_collection'"
              v-model="$store.state.values"
              @submit="handleSubmit"
              :schema="$store.state.schema"
              :devicesSchema="$store.state.schemaCollection.devices"
              :deviceInventory="$store.state.deviceInventory"
              :softwareFilters="$store.state.softwareFilters"
            ></channel-form>

            <v-card v-else-if="($store.state.context == 'edit' || $store.state.context == 'add') && $store.state.nodeType != 'channel_collection'">
              <v-card-text>
                <form-schema
                  v-model="$store.state.values"
                  @submit="handleSubmit"
                  :schema="$store.state.schema"
                ></form-schema>
              </v-card-text>
            </v-card>

            <v-card v-else class="ma-3">
              <v-card-title>
                <span class="headline">Ready to build your instrumental response !</span>
              </v-card-title>
              <v-card-text>
                The construction of your instrument response will be done in six steps:
                <ol>
                  <li>define (add if not exists) the <strong>network</strong> name and characteristics,</li>
                  <li>define the <strong>station</strong> name and characteristics,</li>
                  <li>define the <strong>location</strong> code,</li>
                  <li>define <strong>channel</strong> characteristics, associate a <strong>sensor</strong> and a <strong>digitizer</strong>, and <strong>additional filters</strong> if needed,</li>
                  <li><strong>visualize</strong> the response graphically,</li>
                  <li><strong>export</strong> the response in <strong>SEED dataless</strong>, <strong>StationXML</strong>, or <strong>JSON</strong> format (JSON will allow you to re-import your response in METEOR).</li>
                </ol>
              </v-card-text>
            </v-card>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-footer app fixed dark height='auto'>
      <v-card class="flex" flat tile>

        <v-card-actions class="blue-grey darken-4 justify-end">
          <span class="ml-5">METadata EditOR</span>
          <span class="ml-1 caption">(v2.0.0)</span>
          <v-spacer></v-spacer>
          <v-menu v-model="citeMenu" top left max-width="500" offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn flat v-on="on">
                <span style="font-size: 40px; position: relative; top: 10px; left: -5px;">&ldquo;</span>
                CITE
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                Jérôme Chèze, Christophe Maron, Diane Rivet, Fabrice Peix, Didier Brunel, Xavier Martin, Bertrand Delouis;
                METEOR: Online Seismic Metadata Builder.
                Seismological Research Letters 2020;; 92 (2A): 1141–1147.
                doi: <a href="https://doi.org/10.1785/0220200217">https://doi.org/10.1785/0220200217</a>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-btn class="mr-5" flat href="mailto:meteor@geoazur.unice.fr?subject=[METEOR]">CONTACT</v-btn>
        </v-card-actions>
      </v-card>
    </v-footer>

    <input id="uploader" type="file" accept=".json" @change="loadJSON">
    <div id="v-app-plugin-container"></div>

  </v-app>
</template>

<script>
import ItemList from './ItemList'

export default {
  components: {
    'item-list': ItemList
  },

  data () {
    return {
      citeMenu: false,
      drawer: true,
      stationDrawer: false,
      exportFormat: [ 'JSON', 'YDBIRD', 'DATALESS', 'STATIONXML' ],
      plotValues: null,
      id: 100,
      fileList: null,
      link: null
    }
  },

  name: 'app',

  mounted () {
    this.$store.dispatch('loadInventory')
    this.link = document.createElement('a')
    this.link.style.display = 'none'
    document.body.appendChild(this.link)
  },

  methods: {

    /**
     * EXPORT
     */
    genFilename (ext) {
      let stamp = new Date().toISOString().replace(/[\-T:]/g, '').split('.')[0]
      return `meteor_${stamp}.${ext}`
    },

    exportMetadata (format) {
      let outfilename = this.genFilename(
        format == 'YDBIRD' ? 'ydbird' :
        format == 'STATIONXML' ? 'xml' :
        format == 'JSON' ? 'json' :
        format == 'DATALESS' ? 'dataless' :
        'txt'
      )
      let outfilemime = format == 'stationxml' ? 'application/xml' : 'text/plain'
      let jsonData = JSON.stringify(this.$store.state.data, null, 2)
      if (format == 'JSON') {
        this.link.setAttribute('download', outfilename)
        this.link.href = `data:${outfilemime},${encodeURIComponent(jsonData)}`
        this.link.click()
      } else {
        let xhr = new XMLHttpRequest()
        xhr.open('POST', `metadata/${format.toLowerCase()}`)
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.responseType = 'text'
        xhr.onload = () => {
          this.link.setAttribute('download', outfilename)
          this.link.href = `data:${outfilemime},${encodeURIComponent(xhr.response)}`
          this.link.click()
        }
        xhr.send(jsonData)
      }
    },

    /**
     * IMPORT
     */
    loadJSON (ev) {
      let getIds = (ids, o) => {
        for (let net of o.network) {
          ids.push(net.id)
        }
        for (let sta of o.station) {
          ids.push(sta.id)
          for (let loc of sta.location) {
            ids.push(loc.id)
          }
          for (let chs of sta.channel_collection) {
            ids.push(chs.id)
          }
        }
      }
      let fr = new FileReader()
      fr.onload = () => {
        let o = JSON.parse(fr.result)
        let ids = []
        getIds(ids, o)
        this.$store.dispatch('setId', Math.max.apply(null, ids) + 1)
        this.$store.dispatch('setData', o)
      }
      fr.readAsText(ev.target.files[0])
    },

    getNodeMapping () {
      let nodeMapping = {
        network: {},
        location: {}
      }
      for (let network of this.$store.state.data.network) {
        nodeMapping.network[network.id] = network
      }
      for (let location of this.$store.state.stationNode.location) {
        nodeMapping.location[location.id] = location
      }
      return nodeMapping
    },


    /**
     * ACTION HANDLERS
     */
    handleDisplay (nodeType, node) {
      this.$store.dispatch('display', { node, nodeType })
      if (nodeType == 'station') {
        this.stationDrawer = true
      } else if (nodeType == 'channel_collection') {
        this.plotValues = null
      }
    },

    handleAdd (nodeType) {
      this.$store.dispatch('addNode', nodeType)
    },

    handleEdit () {
      this.$store.dispatch('edit')
    },

    handleDelete () {
      let node = this.$store.state.node
      let nodeType = this.$store.state.nodeType
      if (!this.$store.getters.canDeleteNode(node.id)) {
        this.$notify({
          color: 'error',
          message: `Cannot delete this ${nodeType} because some channels reference it.`
        })
        return
      }
      this.$confirm({
        title: 'Warning',
        message: `This ${nodeType} will be permanently deleted. Continue?`
      }).then(() => {
        if (nodeType == 'station') {
          this.stationDrawer = false
        }
        this.$store.dispatch('deleteNode')
        this.$notify({ color: 'success', message: 'Delete completed' })
      }).catch(() => {
        this.$notify({ color: 'info', message: 'Delete canceled' })
      })
    },

    handleClone () {
      this.$store.dispatch('cloneNode')
    },

    handleSubmit () {
      this.$store.dispatch('submit')
      if (this.$store.state.nodeType == 'station') {
        this.stationDrawer = true
      }
    },

    handlePlotResponse () {
      let node = this.$store.state.node

      // get sensor type
      let sensorType = this.$store.getters.sensorType

      // create JSON struct
      let staNode = JSON.parse(JSON.stringify(this.$store.state.stationNode))
      staNode.location = staNode.location.filter(x => x.id == node.data.location)
      staNode.channel_collection = [ node ]
      let jsonData = {
        network: this.$store.state.data.network.filter(x => x.id == node.data.network),
        station: [ staNode ],
        version: '1.0'
      }

      // build seed ids
      let chPrefix = [
        jsonData.network[0].data.fdsn,
        staNode.data.iris_code,
        staNode.location[0].data.code
      ].join('.')
      let seedIds = node.data.channel.map(x => `${chPrefix}.${x.iris_code}`)

      // send request
      let xhr = new XMLHttpRequest()
      xhr.open('POST', `plot_response?seedids=${seedIds.join(',')}&time=${node.data.open}&type=${sensorType}`)
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.responseType = 'json'
      xhr.onload = () => {
        this.plotValues = xhr.response
      }
      xhr.send(JSON.stringify(jsonData, null, 2))
    }

  }
}
</script>
